export default class {
  /**
   *
   * @param {HTMLElement} htmlElement
   */
  constructor(htmlElement) {
    this.view = htmlElement;
    window.addEventListener('scroll', e => this.update());
    this.update();
    window.cartShortcut = this;
  }

  update(){
    const scrollHeight = window.innerHeight || Math.max(document.documentElement.clientHeight, document.body.clientHeight);
    const scrollTop    = document.documentElement.scrollTop;
    const scrollBottom = scrollHeight + scrollTop;
    const overflow     = scrollBottom < (this.view.getBoundingClientRect().top + scrollTop);

    if(overflow){
      if( !this.view.classList.contains('cart-shortcut-float') ){
        this.view.classList.add('cart-shortcut-float');
      }
    }else{
      if( this.view.classList.contains('cart-shortcut-float') ){
        this.view.classList.remove('cart-shortcut-float');
      }
    }
  }
}